import moment from "moment-timezone";
export const getCardsData = (item) => {
    if (!item || (typeof item === 'object' && !Array.isArray(item) && Object.keys(item).length === 0)) {
        return [];
    }
    return [
        {
            id: 1,
            title: "Total orders",
            subTitle: "Today",
            icon: "user",
            iconBgColor: "warning",
            items: [
                `Orders: ${item?.today?.totalOrders}`,
                `Revenue:  ₹${item?.today?.totalRevenue}`,
            ]
        },
        {
            id: 2,
            title: "Total cash orders",
            subTitle: "Today",
            icon: "user-check",
            iconBgColor: "danger",
            items: [
                `Orders: ${item?.today?.cash.count}`,
                `Revenue:  ₹${item?.today?.cash.revenue}`,
            ]
        },
        {
            id: 3,
            title: "Total online orders",
            subTitle: "Today",
            icon: "calendar-check",
            iconBgColor: "warning",
            items: [
                `Orders: ${item?.today?.online.count}`,
                `Revenue:  ₹${item?.today?.online.revenue}`,
            ]
        },
        {
            id: 4,
            title: "Total orders",
            subTitle: "Last Month",
            icon: "calendar-day",
            iconBgColor: "success",
            items: [
                `Orders: ${item?.lastMonth?.totalOrders}`,
                `Revenue:  ₹${item?.lastMonth?.totalRevenue}`,
                `Pending Payment:  ${item?.lastMonth?.pendingPaymentsCount}, Amount:  ₹${item?.lastMonth?.pendingPaymentsAmount}`,
            ]
        }
    ];
}

export const getRestaurantCardsData = (item, feedback) => {
    if (
        !item ||
        (typeof item === "object" && !Array.isArray(item) && Object.keys(item).length === 0)
    ) {
        return [];
    }

    // First card: all branches total
    const cards = [
        {
            id: 1,
            title: "Total orders",
            subTitle: "Today",
            icon: "user",
            iconBgColor: "warning",
            items: [`Orders: ${item?.allBranchTotalOrders}`],
        },
    ];

    // Add one card for each branch
    if (Array.isArray(item.Summarydata)) {
        item?.Summarydata.forEach((branch, index) => {
            cards.push({
                id: index + 2, // unique id after the first one
                title: branch?.branchName,
                subTitle: "Today",
                icon: "user-check",
                iconBgColor: "danger",
                items: [`Orders: ${branch.totalOrders}`],
            });
        });
    }

    if (feedback) {
        const nextId = cards.length + 1;
        cards.push({
            id: nextId,
            title: 'Contact us',
            subTitle: "All",
            link: '/contact',
            icon: "feedback",
            iconBgColor: "info",
            items: [`Response: ${feedback}`],
        });
    }

    return cards;
};

export const getEmployeeCardsData = (item) => {
    if (
        !item ||
        (typeof item === "object" && !Array.isArray(item) && Object.keys(item).length === 0)
    ) {
        return [];
    }

    // items can be orderSummary object (having orderStatus array) or the order array itself
    const orders = item?.orderStatus || (Array.isArray(item) ? item : []);

    const newOrders = orders.filter((order) => (order.orderStatus ?? order.status) === 0).length;
    const completedOrders = orders.filter((order) => (order.orderStatus ?? order.status) === 3).length;
    const inProgress = orders.filter((order) => (order.orderStatus ?? order.status) !== 3 && (order.orderStatus ?? order.status) !== 0 && (order.orderStatus ?? order.status) !== -2).length;
    const rejectedOrders = orders.filter((order) => (order.orderStatus ?? order.status) === -2).length;

    return [
        {
            id: 1,
            title: "New orders",
            subTitle: "Today",
            icon: "shopping",
            iconBgColor: "warning",
            items: [`Orders: ${newOrders}`],
        },
        {
            id: 2,
            title: "In Progress",
            subTitle: "Today",
            icon: "update",
            iconBgColor: "warning",
            items: [`Orders: ${inProgress}`],
        },
        {
            id: 3,
            title: "Completed orders",
            subTitle: "Today",
            icon: "user-check",
            iconBgColor: "success",
            items: [`Orders: ${completedOrders}`],
        },
        {
            id: 4,
            title: "Rejected orders",
            subTitle: "Today",
            icon: "cancel",
            iconBgColor: "danger",
            items: [`Orders: ${rejectedOrders}`],
        },
    ];
};

export const getEmployeeChartData = (orders = []) => {
    const timezone = "Asia/Kolkata";

    // Create 24 hours with 0 count
    const timeMap = {};

    for (let hour = 0; hour < 24; hour++) {
        const label = moment()
            .hour(hour)
            .minute(0)
            .format("HH:00");

        timeMap[label] = 0;
    }

    //Count orders per hour
    let totalOrders = 0;

    orders.forEach(order => {
        if (!order.orderTime) return;

        totalOrders++;

        const hourLabel = moment(order.orderTime)
            .tz(timezone)
            .format("HH:00");

        if (timeMap[hourLabel] !== undefined) {
            timeMap[hourLabel] += 1;
        }
    });

    //Convert to chart format
    const timeBreakdown = Object.entries(timeMap).map(
        ([time, count]) => ({
            time,
            totalOrders: count
        })
    );

    return {
        totalOrders,
        pendingPaymentsCount: 0,
        timeBreakdown
    };
};